module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "speed-select"
    }
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Choose the XMission Fiber speed for this address")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.speedOptions.speed_options), function(option) {
    return _c('label', {
      key: option.speed_id,
      on: {
        "click": function($event) {
          return _vm.setSpeedDetails(option)
        }
      }
    }, [_c('input', {
      staticClass: "speed-radio",
      attrs: {
        "type": "radio",
        "name": "speed"
      }
    }), _vm._v(" "), _c('div', {
      class: ['package', option.speed_color]
    }, [_c('h4', [_vm._v(_vm._s(option.speed_label) + " "), _c('small', [_vm._v("upload and download")])]), _vm._v(" "), _c('div', {
      staticClass: "promo-fmf"
    }, [_vm._v(_vm._s(option.early_net_connectivity_rate_term))]), _vm._v(" "), _c('b', {
      staticClass: "price"
    }, [_vm._v("$" + _vm._s(option.monthly_gross_connectivity_rate))]), _vm._v("/mo\n        "), _c('small', {
      staticClass: "breakdown"
    }, [_vm._v(_vm._s(option.monthly_gross_connectivity_rate_breakdown))]), _vm._v(" "), (option.speed_id !== 'speed_10000_sym') ? _c('span', [_c('div', {
      staticClass: "promo-2dollars xm-g-bg"
    }, [_vm._v("$"), _c('b', [_vm._v(_vm._s(option.monthly_gross_connectivity_router_rate))]), _vm._v("/mo when you add "), _c('b', [_vm._v("XWi Home")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(option.speed_description))])]) : _c('span', [_c('p', {
      staticClass: "mb-0"
    }, [_c('img', {
      staticClass: "float-left mr-2",
      attrs: {
        "src": "https://asset.xmission.com/xwi/xwi-router-white.png",
        "width": "90",
        "alt": "XWi router white"
      }
    }), _vm._v("\n              10Gbps comes bundled with "), _c('img', {
      staticStyle: {
        "height": "20px",
        "vertical-align": "baseline"
      },
      attrs: {
        "src": _vm.xwiLogoUrl,
        "alt": "XWi"
      }
    }), _vm._v(" including router & app.\n            ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mr-3",
    staticStyle: {
      "line-height": "normal"
    }
  }, _vm._l((_vm.legalDisclaimers), function(promo_legal_disclaimer) {
    return _c('span', [_c('b', [_vm._v(_vm._s(promo_legal_disclaimer.label))]), _vm._v(": "), _c('small', [_vm._v(_vm._s(promo_legal_disclaimer.disclaimer))]), _vm._v(" \n      ")])
  }), 0)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb934e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/SpeedSelect.vue
// module id = 1323
// module chunks = 16